import { DoaForecastFilterBoardType, SortType } from "../doa-forecast-stats/DoaForecastStatsModels";
import { Status } from "../doa-forecast/DoaForecastModels";

export interface IAvailableListItem {
  employeeFullName: string,
  lastWorkedDate: string | null,
  suspensionLevelDescription: string,
  plateColour: string,
  jobOrReason: string,
  jobColour: string,
  isAssigned: boolean,
  regId: number,
  boardPlate: string,
  board: string,
  primaryPhoneNumber: string,
  altPhoneNumber: string,
  cellPhoneNumber: string
}

export interface IAvailableList {
  jobId: number;
  flag545: number;
  list: IAvailableListItem[]
}

export interface IShortageBoardOptions {
  boardCode: string,
  boardDescription: string
}

export interface IShortageCandidateInfo {
  sortCandidatePosition: number,
  employeeFullName: string,
  employeeLastName: string | null,
  lastOrderDate: string | null,
  lastDespatchShiftDescription: string | null,
  epdSuspensionLevelDescription: string,
  insertColor: string,
  graveyardShiftPercentage: number,
  dayShiftPercentage: number,
  nightShiftPercentage: number,
  registrationNumber: number,
  boardCode: string,
  plate: number,
  phonePrimary: string | null,
  phoneAlternate: string | null,
  phoneCell: string | null,
  lua: string,
  boardDescription: string,
  sortButtonPosition: number,
  isCallback: boolean,
  callbackDetails: string,
  hasBeenContacted: boolean,
  isInSquamishComplement: boolean,
  isRwf: boolean,
  isAvailable?: boolean,
  errorMsg?: string,
}

export interface IShortageListItem {
  sortBoardPosition: number,
  boardCode: string,
  boardDescription: string,
  isCasual: boolean,
  buttonInfo: { buttonDescription: null | string, buttonImage: null | string, plateNumber: null | number }[],
  candidateInfo: IShortageCandidateInfo[],
}

export interface IShortageList {
  jobId: number;
  flag545: number;
  list: IShortageListItem[];
  boardOptions: IShortageBoardOptions[];
}

export interface IShortageListRawData {
  jobId: number;
  flag545: number;
  boardData: IShortageListItem[];
  boardOptions: IShortageBoardOptions[];
  candidateInfo: IShortageCandidateInfo[];
}

export interface IShortageListFilter {
  selectedBoardType: DoaForecastFilterBoardType,
  selectedBoardFilter: string,
  selectedSortType: SortType,
  selectedNameFilter: string,
  includeCallback: boolean,
}

export type JobDetail = {
  jobDetail: string;
  jobsRequired: number;
  totalAvailable: number;
  matchedAvailable: number;
  tsc: number;
  short: number;
}

export type JobStats = {
  jobId: number;
  flag545: number;
  jobDescription: string;
  jobsRequired: number;
  totalAvailable: number;
  matchedAvailable: number;
  tsc: number;
  short: number;
  jobDetails: JobDetail[]
}

export enum DetailsItemType {
  regular = 'regular',
  coastwise = 'coastwise',
  jobs = 'squamish'
}

export type DetailsItem = {
  type: DetailsItemType,
  snapshotStartIndex: number,
  snapshotEndIndex: number,
  jobStats: JobStats[]
};

export interface IDoaForecastStatsDispatch {
  dispatchDate: string;
  dispatch: string;
  dispatchDescription: string;
  availabilityStatus: Status;
  physicalDispatchStatus: Status;
  jobRequired: number;
  totalEmployees: number;
  totalEmployeesNotEligible: number;
  totalEmployeesEligible: number;
  lastUpdate: string | null;
  lastRefresh: string | null;
  details: DetailsItem[];
  refreshTime: string;
  refreshTimeContext: string;
}

export interface IDoaForecastStatsData {
  dispatchData: IDoaForecastStatsDispatch,
  availabilityList: IAvailableList,
  shortagesList: IShortageList,
}
